module.exports = __webpack_public_path__ + "img/axess.1993784a.svg";